export default [
  {
    path: 'gestao/entidades',
    name: 'entidades',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Rede',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Rede' }
      ]
    }
  },
]